import React from 'react'
import './button.scss'

const Button = ({ text, action, gradient, disabled = false, url }) => {
	const className = `f-button ${url ? 'f-button--link' : ''} ${gradient} ${
		disabled ? 'disabled' : ''
	}`
	const target = url && url.includes('https') ? '_blank' : '_self'

	return url ? (
		<a className={className} href={url} target={target}>
			{text}
		</a>
	) : (
		<button className={className} onClick={action} disabled={disabled}>
			{text}
		</button>
	)
}

export default Button
